export default __webpack_public_path__ + "static/media/Ford_Takeover_3.4f147955.jpg";